module.exports = __webpack_public_path__ + "img/sdg_en_(17).5e3516f9.png";